/* tslint:disable */
/* eslint-disable */
/* @relayHash e0de7cce15234eef43595e788cadbc9b */

import { ConcreteRequest } from "relay-runtime";
export type initAutopilotQueryVariables = {
    anchors?: Array<string> | null;
};
export type initAutopilotQueryResponse = {
    readonly viewer: {
        readonly anchorLists: ReadonlyArray<{
            readonly __typename: string;
        } | null> | null;
        readonly disableAutopilotIntegration: boolean | null;
    };
};
export type initAutopilotQuery = {
    readonly response: initAutopilotQueryResponse;
    readonly variables: initAutopilotQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "anchors",
    "type": "[String!]",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "anchors",
    "variableName": "anchors"
  },
  {
    "kind": "Literal",
    "name": "listNames",
    "value": [
      "LEAD_NURTURING_BUYER_WHITELIST"
    ]
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": "disableAutopilotIntegration",
  "name": "isEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "disableAutopilotIntegration"
    }
  ],
  "storageKey": "isEnabled(key:\"disableAutopilotIntegration\")"
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "initAutopilotQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "anchorLists",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "AnchorList",
            "plural": true,
            "selections": [
              (v2/*: any*/)
            ]
          },
          (v3/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "initAutopilotQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "anchorLists",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "AnchorList",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/)
            ]
          },
          (v3/*: any*/),
          (v4/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "initAutopilotQuery",
    "id": "ferrum/270.0.0-2020-06-18T22:37:41.615Z/initAutopilotQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '21832c18b05b24130309ac034117d83f';
export default node;
